export default function PageLoading() {
  return (
    <div
      className="flex min-h-[40vh] flex-col items-center justify-center gap-3 py-16"
      role="status"
      aria-live="polite"
      aria-label="Loading page"
    >
      <div className="h-9 w-9 animate-spin rounded-full border-2 border-border border-t-primary" />
      <p className="text-sm text-muted">Loading…</p>
    </div>
  );
}
